"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var CreateButton_1 = __importDefault(require("@components/Buttons/CreateButton/CreateButton"));
var s = __importStar(require("./Profile.module.scss"));
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var authSlice_1 = require("@store/slices/authSlice");
var passwordVerification_1 = __importDefault(require("@utils/passwordVerification"));
var auth_1 = require("@services/auth");
var modalSlice_1 = require("@store/slices/modalSlice");
var gddSlice_1 = require("@store/slices/gddSlice");
var withConfirmationModal_1 = __importDefault(require("@components/_hoc/withConfirmationModal"));
var loaderSlice_1 = require("@store/slices/loaderSlice");
function ProfileForm(_a) {
    var modalRef = _a.modalRef, showConfirmationModal = _a.showConfirmationModal, setProfileVisible = _a.setProfileVisible;
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.authSlice; }), username = _b.username, email = _b.email;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _c = (0, react_1.useActionState)(handlePasswordChange, null), data = _c[0], action = _c[1];
    var _d = (0, react_1.useState)(""), submitMessage = _d[0], setSubmitMessage = _d[1];
    var _e = (0, react_1.useState)(false), isFormVisible = _e[0], setFormVisible = _e[1];
    (0, useClearOnTime_1.default)({ setText: setSubmitMessage, text: submitMessage });
    function handlePasswordChange(prevState, data) {
        return __awaiter(this, void 0, void 0, function () {
            var old, fist, second, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        old = data.get("old_pass");
                        fist = data.get("first_pass");
                        second = data.get("second_pass");
                        if (!fist || !old || !second) {
                            setSubmitMessage("all fields are required");
                            return [2 /*return*/];
                        }
                        if (fist !== second) {
                            setSubmitMessage("passwords do not match");
                            return [2 /*return*/];
                        }
                        if (!(0, passwordVerification_1.default)(fist === null || fist === void 0 ? void 0 : fist.toString())) {
                            setSubmitMessage("this password is too weak");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, auth_1.updatePasswordAPI)(old.toString(), fist.toString())];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: "Success!!!" }));
                            setFormVisible(false);
                            return [2 /*return*/];
                        }
                        setSubmitMessage(res.message);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({
                            activeModal: modalSlice_1.ActiveModal.Info,
                            text: "Something went wrong",
                        }));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleAccountDeletion() {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch((0, loaderSlice_1.setLoading)(true));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, auth_1.deleteAccountAPI)()];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            handleLogout();
                        }
                        else {
                            dispatch((0, modalSlice_1.showModal)({
                                activeModal: modalSlice_1.ActiveModal.Info,
                                text: "Something went wrong",
                            }));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({
                            activeModal: modalSlice_1.ActiveModal.Info,
                            text: "Something went wrong",
                        }));
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch((0, loaderSlice_1.setLoading)(false));
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function handleLogout() {
        dispatch((0, authSlice_1.logout)());
        dispatch((0, gddSlice_1.closeGDD)());
        navigate("/login");
    }
    function handleDeleteAccountClick() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!showConfirmationModal)
                    return [2 /*return*/];
                showConfirmationModal("You are about to delete your account!\n Are you sure ?", function () { return handleAccountDeletion(); });
                return [2 /*return*/];
            });
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { ref: modalRef, className: s.profile_content_wrapper, children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)("button", { className: s.close_btn, onClick: function () { return setProfileVisible(false); }, children: "x" }) }), (0, jsx_runtime_1.jsxs)("div", { className: s.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "", children: "Name:" }), (0, jsx_runtime_1.jsx)("input", { type: "text", readOnly: true, value: username })] }), (0, jsx_runtime_1.jsxs)("div", { className: s.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "", children: "Email:" }), (0, jsx_runtime_1.jsx)("input", { type: "text", readOnly: true, value: email })] }), (0, jsx_runtime_1.jsx)("div", { className: s.form_group, children: (0, jsx_runtime_1.jsx)("button", { className: s.reset_password_btn, onClick: function () { return setFormVisible(!isFormVisible); }, children: "password reset" }) }), isFormVisible ? ((0, jsx_runtime_1.jsxs)("form", { action: action, className: s.reset_password_form, children: [(0, jsx_runtime_1.jsxs)("div", { className: s.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "", children: "Old Password:" }), (0, jsx_runtime_1.jsx)("input", { type: "password", id: "old_pass", name: "old_pass" })] }), (0, jsx_runtime_1.jsxs)("div", { className: s.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "", children: "New Password:" }), (0, jsx_runtime_1.jsx)("input", { type: "password", id: "first_pass", name: "first_pass" })] }), (0, jsx_runtime_1.jsxs)("div", { className: s.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "", children: "Confirm Password:" }), (0, jsx_runtime_1.jsx)("input", { type: "password", id: "second_pass", name: "second_pass" })] }), submitMessage.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "".concat(s.form_group, " ").concat(s.error), children: submitMessage })) : null, (0, jsx_runtime_1.jsx)("button", { children: "Submit" })] })) : null, (0, jsx_runtime_1.jsxs)("div", { className: s.footer, children: [(0, jsx_runtime_1.jsx)(CreateButton_1.default, { title: "LOGOUT", action: handleLogout }), (0, jsx_runtime_1.jsx)("button", { role: "button", className: s.delete_account_btn, onClick: handleDeleteAccountClick, children: "delete account" })] })] }));
}
exports.default = (0, withConfirmationModal_1.default)(ProfileForm);
